<nav class="navbar">
  @if (isMobile()) {
    <div class="button-container">
      <button
        matMiniFab
        class="navbar-toggler"
        type="button"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        (click)="toggleSidebarOutput.emit()"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  }

  <div class="container-user" id="navbarSupportedContent">
    <div class="img-container">
      <img
        title="Project logo"
        class="img-wrapper"
        [src]="selectedProjectLogo()"
        [alt]="selectedProjectName() + ' logo'"
        appFallbackSrc
      />
    </div>

    <ul class="user-info">
      <li class="theme">
        <app-theme-toggle />
      </li>

      <!-- <li class="language-selector-item">
        <app-language-selector />
      </li> -->

      <li class="profile-container">
        <span class="user-name">
          {{'layout.top.welcome' | translate}} {{username()}}
        </span>
        <app-profile-options
          [userEmail]="userEmail()"
          [userName]="username()"
          (logoutRequested)="onLogout()"
        ></app-profile-options>
      </li>
    </ul>
  </div>
</nav>
